import type { DocMigration } from "../docMigration";

function isFormula(v: any): boolean {
  return !!v && typeof v === "object" && v.hasOwnProperty("type") && v.type === "FORMULA";
}

const docEntityTableFieldsToEntityType = {
  underlays: "UNDERLAY",
  assets: "ASSET",
  backupPropSettingsSets: "SETTINGS",
  blocks: "BLOCK",
  rooms: "ROOM",
  roomLayouts: "ROOM_LAYOUT",
  roomLayoutInstances: "ROOM_LAYOUT_INSTANCE",
  stairSystems: "STAIR_SYSTEM",
  stairBlocks: "STAIR_BLOCK",
  railings: "RAILING",
  railingPosts: "RAILING_POST",
  roofSystems: "ROOF_SYSTEM",
  selectors: "SELECTOR",
  viewOverrides: "VIEW_OVERRIDE",
  viewSelectors: "VIEW_SELECTOR",
  roofs: "ROOF",
  roofVolumes: "ROOF_VOLUME",
  foundationSystems: "FOUNDATION_SYSTEM",
  foundations: "FOUNDATION",
  elevations: "ELEVATION",
  facades: "FACADE",
  facadeSpanStrata: "FACADE_SPAN_STRATUM",
  facadeSweepStrata: "FACADE_SWEEP_STRATUM",
  referenceGeom: "REFERENCE_GEOM",
  sheets: "SHEET",
  drawingRefs: "DRAWING_REF",
  palettes: "PALETTE",
  annotation: "ANNOTATION",
  edgeBehaviors: "EDGE_BEHAVIOR",
  casework: "CASEWORK",
  ceilings: "CEILING",
  propInstances: "PROP_INSTANCE",
  propDefs: "PROP_DEF",
  propAttributes: "PROP",
  levels: "LEVEL",
  roofOpenings: "ROOF_OPENING",
  groups: "GROUP",
  settingsSets: "SETTINGS_SET",
  entitySettings: "ENTITY_SETTINGS",
  settings: "SETTINGS",
  optionTemplates: "OPTION_TEMPLATE",
  dormers: "DORMER",
  skylights: "SKYLIGHT",
  modifiers: "MODIFIER",
  edgeModifiers: "EDGE_MODIFIER",
  measurements: "MEASUREMENT",
  openings: "OPENING",
  floors: "FLOOR",
  floorFinishes: "FLOOR_FINISH",
  sites: "SITE",
  siteShapes: "SITE_SHAPE",
  optionEffects: "OPTION_EFFECT",
  optionRules: "OPTION_RULE",
  optionSetOverrides: "OPTION_SET_OVERRIDES",
  optionSets: "OPTION_SET",
  optionLocks: "OPTION_LOCK",
  auxOptionSets: "AUX_OPTION_SET",
  columns: "COLUMN",
  view3Ds: "VIEW_3D",
  planViews: "PLAN_VIEW",
  elevationViews: "ELEVATION_VIEW",
  optionSetRefs: "OPTION_SET_REF",
  builderRefs: "BUILDER_REF",
  electricalDevices: "ELECTRICAL_DEVICE",
  electricalLayouts: "ELECTRICAL_LAYOUT",
  planSetTemplates: "PLAN_SET_TEMPLATE",
  planSetTemplateConfigs: "PLAN_SET_TEMPLATE_CONFIG",
  contentTemplates: "CONTENT_TEMPLATE",
  contentTemplateInstances: "CONTENT_TEMPLATE_INSTANCE",
  contentReplicators: "CONTENT_REPLICATOR",
  localParameters: "LOCAL_PARAMETER",
  globalParameters: "GLOBAL_PARAMETER",
  viewports: "VIEWPORT",
  viewTemplates: "VIEW_TEMPLATE",
  viewTemplateOverrides: "VIEW_TEMPLATE_OVERRIDE",
  dataTables: "DATA_TABLE",
  dataSequences: "DATA_SEQUENCE",
  sectionViews: "SECTION_VIEW",
  presets: "PRESET",
  entityTags: "ENTITY_TAG",
  effects: "EFFECT",
  datums: "DATUM",
  ruleBasedSelectors: "RULE_BASED_SELECTOR",
  ruleBasedSelectorInstances: "RULE_BASED_SELECTOR_INSTANCE",

  // Not entity types
  locked: undefined,
  hidden: undefined,
  entityRoomLayouts: undefined,
  entityGroups: undefined,
  entityRefs: undefined,
  optionChoices: undefined,
  docRefs: undefined,
  facadeSpanStratumAssociations: undefined,
  facadeSweepStratumAssociations: undefined,
  datumSpanAssociations: undefined,
} as const;

const docEntityTableToFormulaField: { [key in keyof typeof docEntityTableFieldsToEntityType]?: string } = {
  optionLocks: "disconnectConditionOptions",
  optionRules: "predicate",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_462: DocMigration = {
  maxSchemaVersion: "0.0.462",
  description: "Replace formula 'not (true)' with undefined value for entity disabled property",
  apply(json: any) {
    for (const field in json) {
      const isDocTableEntity = !!docEntityTableFieldsToEntityType[field];

      if (!isDocTableEntity) {
        continue;
      }

      const docTable = json[field];
      const formulaField = docEntityTableToFormulaField[field] ?? "disabled";

      for (const entityId in docTable) {
        const entity = docTable[entityId];

        if (!(formulaField in entity)) {
          continue;
        }

        const formula = entity[formulaField];

        if (!isFormula(formula) || formula.formula !== "not (true)") {
          continue;
        }

        entity[formulaField] = undefined;
        json[field][entityId] = entity;
      }
    }

    return json;
  },
};
export default migration_0_0_462;
